import { createSelector } from 'helpers/reselect'
import { getPageLocation } from 'selectors'
import { GLOBAL_SEARCH_QUERY_KEY } from 'constant'
import { TIRES_FILTER_GROUP_NAME } from './constants'

export const getGlobalSearchDisplay = ({ globalSearchPage: { displayGlobalSearch }}) => displayGlobalSearch

export const getFilterData = ({ globalSearchPage: { filters }}) => filters

export const getSearchQuery = state => {
  const { search } = getPageLocation(state)

  if (!search) return

  // Omit question mark in search, split query parameters, find needed
  const [, value] = search.slice(1).split('&')
    .map(queryParameter => queryParameter.split('='))
    .find(([key]) => key === GLOBAL_SEARCH_QUERY_KEY) || []

  if (value.includes('+')) {
    const formattedValue = value.replaceAll('+', ' ')
    return decodeURIComponent(formattedValue)
  }

  return decodeURIComponent(value)
}

export const getTiresFilterData = createSelector(
  [getFilterData],
  filters =>
    (filters.find(({ filterGroup }) =>
      filterGroup === TIRES_FILTER_GROUP_NAME) || {}).navigation || []
)

export const getTiresSelectedFilters = createSelector(
  [getTiresFilterData],
  filters =>
    filters.reduce((acc, curr) => {
      if (curr.refinements) {
        return [...acc, ...curr.refinements.filter(({ selected }) => selected)]
      }

      return acc
    }, [])
)
